var resultWidth = 0, resultLength = 0, showWidth = 0, showLength = 0;

$('.popupContainer.measurement').on('click', function () {
  setThemeGuideOpen(this, false);
})
 
$('.popupContainer.measurement .popupBox .popupTitle svg').on('click', function () {
  $(this).closest('.popupContainer').click();
}) 

$('.popupContainer.measurement .popupBox').on('click', function (event) {
  event.stopPropagation();
})

$('.popupContainer.measurement .popupBox .popupBody .step > div').on('click', function () {
  if ($(this).attr('disabled') == 'disabled') {
    return;
  }

  scrollChangeNum({
    ele: '.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList',
    direction: 'horizontal',
    num: $(this).index()
  });

  if ($(this).index() + 1 >= $('.popupContainer.measurement .popupBox .popupBody .step > div').length) {
    resultChange();
  }
  // 底部按钮展示
  $('.btnList .btns').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'none' : 'flex');
  $('.btnList > .btn').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'flex' : 'none');
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').on('click', function () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());
  var inputType = false, optionType = false;

  if (currentStep.find('.option:not([col="1"])').length > 0) {
    optionType = currentStep.find('.optionItem.active').length == 0;
  }

  $.each(currentStep.find('input[required]'), function (i, item) {
    $(item).css('border-color', $(item).val().length == 0 || $(item).val() == 0 ? '#b11500' : '#1F1F1F');
    if ($(item).val().length == 0 || $(item).val() == 0) {
      inputType = true;
    }
  });

  currentStep.find('.option').css('border-color', optionType ? '#b11500' : 'transparent');

  if (inputType || optionType) {
    return;
  }

  stepChange();
})

function stepChange () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());
  // true: 有杆子; false: 无杆子;
  var isRod = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(2) .first .optionItem.active').attr('data-value') == 'true';

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .first .optionItem[data-value="true"]').css('display', isRod ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .first .inputList > .msg span.rodMsg').css('display', isRod && isIndoor ? 'block' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .first .inputList > .msg span.grommettopbottomMsg').css('display', isOutdoor ? 'block' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .first .optionItem[data-value="false"]').css('display', isRod ? 'none' : 'flex');

  if (!isRod && currentStep.find('.first').length > 0 && currentStep.find('.first').css('display') != 'none') {
    // 无杆子
    currentStep.find('.first').css('display', 'none');
    currentStep.find('.branch').css('display', 'flex');
    return;
  }

  if (current.next().index() == 3 && isOutdoor) {
    current.next().next().removeAttr('disabled').click();
    $('.nextStep').attr('click-data', `SizeGuideStep${current.next().next().index() + 1}`);
  } else {
    current.next().removeAttr('disabled').click();
    $('.nextStep').attr('click-data', `SizeGuideStep${current.next().index() + 1}`);
  }
}

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 1
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? $(list.ele)[0].scrollHeight : $(list.ele)[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? $(list.ele).find('>*:first-of-type').outerHeight() : $(list.ele).find('>*:first-of-type').outerWidth();
  // 子元素间距
  var elechilrenSpace = (eleScroll - elechilrenSize * $(list.ele).find('>*').length) / ($(list.ele).find('>*').length - 1);

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.direction == 'vertical') {
    $(list.ele).animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    $(list.ele).animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.first').css('display', 'flex');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.branch').css('display', 'none');

  $('.popupContainer.measurement .popupBox .popupBody .step > div').removeClass('active');
  $('.popupContainer.measurement .popupBox .popupBody .step > div').eq(list.num).removeAttr('disabled').addClass('active');
}

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('change', function () {
  $(this).val(Math.round(Math.abs($(this).val())));
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('keydown', function () {
  if (event.which == 13) {
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').click();
  }
})

$('.popupContainer.measurement .popupBox .btns .btn').on('click', function () {
  var type = $(this).attr('type');

  if (type == 'white') {
    // reset
    resultType = false;
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .optionItem').removeClass('active');
    $('.popupContainer.measurement .popupBox input').val('');
    $('.popupContainer.measurement .popupBox .popupBody .step > div:not(:first-of-type)').removeClass('active').attr('disabled', true);
    $('.popupContainer.measurement .popupBox .popupBody .step > div:first-of-type').click();
  }

  if (type == 'black' && $('.outChangeMsg').css('display') == 'none') {
    // shop now
    resultType = false;
    var header = $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:first-of-type .option .optionItem.active`).attr('data-value');
    var panel = parseInt($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(5) .optionItem.active').attr('data-value'));
    $(`input[name="properties[Header Type]"][value="${header}"] + label`).click();
    // 使用与 SIZE GUIDE 按钮一致的宽度/长度选择器，支持 Panel Width/Length 和 Track Width/Length
    $('select[name*="Width]"]').closest('.selector-wrapper').find('.selectInput').val(`${showWidth}${ unitType }`);
    $('select[name*="Length]"]').closest('.selector-wrapper').find('.selectInput').val(`${showLength}${ unitType }`);
    $('select[name*="Width]"], select[name*="Length]"]').closest('.selector-wrapper').find('.selectInput').closest('item').addClass('active');
    $('select[name*="Width]"]').val(`${resultWidth}"`);
    $('select[name*="Length]"]').val(`${resultLength}"`).change();
    // 上面直接写输入框和 VO、没经过 selectInputChange：补上有效尺寸标记 / 尺寸记忆 / 撤掉"上次尺寸"说明，
    // 否则切单位会按旧标记回填成旧尺寸并照样能加购（见 page_product_gallery.js onMeasurementGuideApplied）
    if (typeof onMeasurementGuideApplied === 'function') onMeasurementGuideApplied(resultWidth, resultLength);
    $('.quantity__input').val(panel).change();
    if (panel <= 1) {
      $('.product__info-container .product-form__buttons .product-form__input .quantity__button[name="minus"]').addClass('disabled');
    } else {
      $('.product__info-container .product-form__buttons .product-form__input .quantity__button[name="minus"]').removeClass('disabled');
    }

    resultType = true;
    $(this).closest('.popupContainer').click();
  }
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .option .optionItem .itemBox').on('click', function () {
  $(this).closest('.option').css('border-color', 'transparent');
  $(this).closest('.option').find('.optionItem').removeClass('active');
  $(this).parent().addClass('active');
  // 选项切换后同步面板文案（处理蛇形帘特殊显示）
  updatePanelLabels();
})

// 根据弹窗中选择的 Header Type 动态更新 Number of Panels 文案
// 蛇形帘(Ripple Fold with Tape Buckle)使用 SINGLE / PAIR 文案
function updatePanelLabels () {
  var header = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:first-of-type .option .optionItem.active').attr('data-value');
  var isRippleFold = header === 'Ripple Fold with Tape Buckle';
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="panel"] .optionItem[data-value="1"] .panelLabel').text(isRippleFold ? 'SINGLE' : '1 PANEL');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="panel"] .optionItem[data-value="2"] .panelLabel').text(isRippleFold ? 'PAIR(TWO EQUAL PANELS)' : '2 PANELS');
}

// 页面初始化时同步一次面板文案
updatePanelLabels();

function resultChange () {
  var windowWidth = 0, windowLength = 0;
  var minWidth = 0, maxWidth = 0, minLength = 0, maxLength = 0;
  
  const fullnessList = {
    "GROMMET TOP": 1.5,
    "GROMMET TOP — SILVER RING": 1.5,
    "GROMMET TOP - SILVER RING": 1.5,
    "GROMMET TOP — SILVER RINGS": 1.5,
    "GROMMET TOP BOTTOM": 1.5,
    "GROMMET TOP BOTTOM - SILVER RING": 1.5,

    "VELCRO TAB TOP": 1.2,
    "TAB TOP": 1.2,

    "BACK TAB & ROD POCKET": 1.5,
    "SINGLE ROD POCKET": 1.5,
    "DOUBLE ROD POCKET": 1.5,
    "DOUBLE ROD POCKETS": 1.5,

    "DOUBLE FRENCH PINCH PLEAT": 1.1,
    "TRIPLE FRENCH PINCH PLEAT": 1.1,
    "INVERTED BOX PLEAT": 1.1,
    "GOBLET": 1.1,
    "EURO PLEAT": 1.1,
    "PLEAT HOOK & CLIP RINGS": 1.5,
    "PLEAT HOOK": 1.5,
    "RIPPLE FOLD WITH TAPE BUCKLE": 2.35
  };
  const fullnessTypeList = ["BACK TAB & ROD POCKET", "SINGLE ROD POCKET", "DOUBLE ROD POCKET", "DOUBLE ROD POCKETS"];

  const rollList = {
    "GROMMET TOP": 2,
    "GROMMET TOP — SILVER RING": 2,
    "GROMMET TOP - SILVER RING": 2,
    "GROMMET TOP — SILVER RINGS": 2,
    "GROMMET TOP BOTTOM": 5,
    "GROMMET TOP BOTTOM - SILVER RING": 5,

    "VELCRO TAB TOP": 1,
    "TAB TOP": 1,

    "BACK TAB & ROD POCKET": 1,
    "SINGLE ROD POCKET": 1,
    "DOUBLE ROD POCKET": 2,
    "DOUBLE ROD POCKETS": 2,

    "DOUBLE FRENCH PINCH PLEAT": -1,
    "TRIPLE FRENCH PINCH PLEAT": -1,
    "INVERTED BOX PLEAT": -1,
    "GOBLET": -1,
    "EURO PLEAT": -1,
    "PLEAT HOOK & CLIP RINGS": -1,
    "PLEAT HOOK": -1,
    "RIPPLE FOLD WITH TAPE BUCKLE": 0
  }
  const rollTypeList = ["DOUBLE ROD POCKET", "DOUBLE ROD POCKETS"];

  var header = $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:first-of-type .option .optionItem.active`).attr('data-value').toUpperCase();
  var width = parseInt($('.popupContainer.measurement .popupBox input[data-type="width"]').val() || 0),
    widthA = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthA"]').val() || 0),
    widthB = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthB"]').val() || 0);
  var height = parseInt($('.popupContainer.measurement .popupBox input[data-type="height"]').val() || 0),
    heightA = parseInt($('.popupContainer.measurement .popupBox input[data-type="heightA"]').val() || 0);
  var fullness = fullnessList[header];
  if (fullnessTypeList.includes(header) && (isSoundproof || isSheer)) {
    fullness = isSoundproof ? 1.2 : isSheer ? 2 : 1.5;
  }
  // 特定产品(8780116951290) Tab Top 按 2 倍 fullness 计算
  if (header === 'TAB TOP' && product.id == 8780116951290) {
    fullness = 2;
  }
  var type
  if(isSheer){
    type = 'Sheer'
  }else if(isSoundproof){
    type = 'Soundproof'
  }else if(isCurtain){
    type = 'Curtain'
  }
  const newFullnessList = {
    "Sheer": {
      "PLEAT HOOK & CLIP RINGS": 2
    },
    "Curtain": {
      "PLEAT HOOK & CLIP RINGS": 1.8
    },
    "Soundproof": {
      "PLEAT HOOK": 1.6
    }
  }
  if (typeof newFullnessList !== 'undefined' && newFullnessList[type] && newFullnessList[type][header] !== undefined) {
    fullness = newFullnessList[type][header];
  }
  var roll = rollList[header];
  if (rollTypeList.includes(header) && !isSoundproof) {
    roll = 2;
  }
  var curtainType = 0;
  var curtainPanel = parseInt($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(5) .optionItem.active').attr('data-value'));

  if ($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(4) .optionItem.active').attr('data-value') != undefined) {
    curtainType = parseInt($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(4) .optionItem.active').attr('data-value'));
  }

  minWidth = SelectRange($('select[name*="Width]"]')).min;
  maxWidth = SelectRange($('select[name*="Width]"]')).max;
  minLength = SelectRange($('select[name*="Length]"]')).min;
  maxLength = SelectRange($('select[name*="Length]"]')).max;

  if (lengthRate != 1) {
    roll = Math.ceil(roll * lengthRate);
    curtainType = Math.ceil(curtainType * lengthRate);
    minWidth = Math.ceil(minWidth * lengthRate);
    maxWidth = Math.ceil(maxWidth * lengthRate);
    minLength = Math.ceil(minLength * lengthRate);
    maxLength = Math.ceil(maxLength * lengthRate);
  }

  var isRod = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(2) .first .optionItem.active').attr('data-value') == 'true';
  if(!isRod){
    windowWidth = width + widthA + widthB;
  }else{
    windowWidth = width;
  }
  windowLength = height + heightA;

  if (header === 'RIPPLE FOLD WITH TAPE BUCKLE') {
    // 蛇形帘宽度直接使用用户输入的测量宽度，不做额外计算
    // windowWidth 已经是：有杆子时 = width，无杆子时 = width + widthA + widthB
    showWidth = Math.round(windowWidth);
    resultWidth = Math.round(windowWidth / lengthRate);

    // 长度按 hover/puddle 调整（与标准逻辑保持一致）
    var cmRate = lengthRate === 1 ? 2.54 : 1;
    var h_cm = windowLength * cmRate;
    if (curtainType > 0) { // puddle selected
      h_cm += 3 * cmRate;
    } else if (curtainType < 0) { // hover selected
      h_cm -= 1 * cmRate;
    }

    showLength = Math.ceil(h_cm / cmRate);
    resultLength = Math.ceil(h_cm / 2.54);
  } else {
    resultWidth = showWidth = Math.ceil(windowWidth * fullness / curtainPanel);
    resultLength = showLength = windowLength + roll + curtainType;

    if (lengthRate != 1) {
      resultWidth = Math.ceil(resultWidth / lengthRate);
      resultLength = Math.ceil(resultLength / lengthRate);
    }
  }

  var sizeText = '';
  var sizeNum = '';
  
  if (showWidth > maxWidth || showWidth < minWidth) {
    sizeText = 'width';
    sizeNum = `${showWidth}${ unitType }`;
  }
  if (showLength > maxLength || showLength < minLength) {
    sizeText = 'length';
    sizeNum = `${showLength}${ unitType }`;
  }
  if ((showWidth > maxWidth || showWidth < minWidth) && (showLength > maxLength || showLength < minLength)) {
    sizeText = 'size';
    sizeNum = `${showWidth}${ unitType } * ${showLength}${ unitType }`;
  }

  // 打印 SHOP NOW 按钮无法点击的原因
  if (sizeNum != '') {
    console.log('Size Guide: SHOP NOW disabled.');
    console.log('Reason:', sizeText, 'out of range');
    console.log('Width:', showWidth, unitType, '| allowed:', minWidth, '-', maxWidth, unitType);
    console.log('Length:', showLength, unitType, '| allowed:', minLength, '-', maxLength, unitType);
  }

  $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').attr('disabled', sizeNum != '');
  if (curtainType != 0) {
    $('.resultTitle').html(`Based on your selected header style ${header} (fullness ${fullness}x), rod size, and finished length (${curtainType > 0 ? 'puddle' : 'hover'}), our recommended order details are as follows:`);
  } else {
    $('.resultTitle').html(`Based on your selected header style ${header} (fullness ${fullness}x), rod size, and finished length, our recommended order details are as follows:`);
  }

  $('.outChangeMsg').html(`Your curtain ${sizeText} (${sizeNum}) exceeds the maximum custom ${sizeText} listed on the product page. No worries — please email our team at <a href="mailto: support@thehues.com">support@thehues.com</a> for a solution.`).css('display', sizeNum != '' ? 'block' : 'none');
  $('.resultSize').html(`<p><span>${curtainPanel}</span>PANEL${curtainPanel > 1 ? 'S' : ''}</p><p><span>${showWidth}${ unitType }</span>WIDE PER PANEL</p><p><span>${showLength}${ unitType }</span>LONG PER PANEL</p>`);
}
